import { render } from "./BlogRightSide.vue?vue&type=template&id=75d1890a"
import script from "./BlogRightSide.vue?vue&type=script&lang=js"
export * from "./BlogRightSide.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__